import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AppDetailComponent } from "./components/app-detail/app-detail.component";
import { AppInfoComponent } from "./components/app-info/app-info.component";
import { AppOverviewComponent } from "./components/app-overview/app-overview.component";
import { DashboardLayoutComponent } from "./components/dashboard-layout/dashboard-layout.component";
import { LandingpageLayoutComponent } from "./components/landingpage-layout/landingpage-layout.component";
import { TagDetailComponent } from "./components/tag-detail/tag-detail.component";
import { TagInfoComponent } from "./components/tag-info/tag-info.component";
import { TagsOverviewComponent } from "./components/tags-overview/tags-overview.component";
import { TestPushComponent } from "./components/test-push/test-push.component";
import { AuthGuardService } from "./services/auth-guard/auth-guard.service";
import { AnalyticsComponent } from "./views/analytics/analytics.component";
import { HomeComponent } from "./views/home/home.component";
import { ImprintComponent } from "./views/imprint/imprint.component";
import { LoginComponent } from "./views/login/login.component";
import { NotfoundComponent } from "./views/notfound/notfound.component";
import { PrivacyComponent } from "./views/privacy/privacy.component";
import { SupportComponent } from "./views/support/support.component";

const routes: Routes = [
  {
    path: "",
    component: LandingpageLayoutComponent,
    children: [
      { path: "", component: LoginComponent },
      {
        path: "resetPassword",
        component: LoginComponent,
        data: { resetPassword: true },
      },
      { path: "register", component: LoginComponent, data: { register: true } },
    ],
  },
  {
    path: "",
    canActivate: [AuthGuardService],
    component: DashboardLayoutComponent,
    children: [
      { path: "", component: HomeComponent, pathMatch: "full" },
      { path: "home", component: HomeComponent, pathMatch: "full" },
      { path: "404", component: NotfoundComponent },
      { path: "imprint", component: ImprintComponent },
      { path: ":clientId/imprint", component: ImprintComponent },
      { path: "privacy", component: PrivacyComponent },
      { path: ":clientId/privacy", component: PrivacyComponent },
      { path: ":clientId/home", component: HomeComponent },
      { path: "apps", component: AppOverviewComponent },
      { path: ":clientId/apps", component: AppOverviewComponent },
      { path: ":clientId/apps/:id", component: AppDetailComponent },
      { path: ":clientId/apps/:id/info", component: AppInfoComponent },
      { path: "tags", component: TagsOverviewComponent },
      { path: ":clientId/tags", component: TagsOverviewComponent },
      { path: ":clientId/tags/:id", component: TagDetailComponent },
      { path: ":clientId/tags/:id/info", component: TagInfoComponent },
      { path: ":clientId/push", component: TestPushComponent },
      { path: ":clientId/analytics", component: AnalyticsComponent },
      { path: ":clientId/support", component: SupportComponent },
    ],
  },
  { path: "**", redirectTo: "/404" },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      enableTracing: false,
      paramsInheritanceStrategy: "always",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
